const savedSearchFields = `
  id
  byUserID
  projectID
  slug
  organizationID
  organizationMasterID
  location { lat lon }
  name source status description address
  conditions provenances categories
  dimensionRange { key min max }
  quantity { number unit }
  brands models materials
  startDate endDate createdAt updatedAt
`

export const savedSearchByProjectQuery = /* GraphQL */ `
  query SavedSearchByProject($projectID: ID!, $limit: Int, $nextToken: String, $filter: ModelSavedSearchFilterInput) {
    savedSearchByProject(projectID: $projectID, limit: $limit, nextToken: $nextToken, filter: $filter) {
      items { ${savedSearchFields} }
      nextToken
    }
  }
`

export const savedSearchByOrganizationQuery = /* GraphQL */ `
  query SavedSearchByOrganization($organizationID: ID!, $limit: Int, $nextToken: String, $filter: ModelSavedSearchFilterInput) {
    savedSearchByOrganization(organizationID: $organizationID, limit: $limit, nextToken: $nextToken, filter: $filter) {
      items { ${savedSearchFields} }
      nextToken
    }
  }
`

export const savedSearchByMasterQuery = /* GraphQL */ `
  query SavedSearchByMaster($organizationMasterID: ID!, $limit: Int, $nextToken: String, $filter: ModelSavedSearchFilterInput) {
    savedSearchByMaster(organizationMasterID: $organizationMasterID, limit: $limit, nextToken: $nextToken, filter: $filter) {
      items { ${savedSearchFields} }
      nextToken
    }
  }
`

export const savedSearchByUserQuery = /* GraphQL */ `
  query SavedSearchByUser($byUserID: ID!, $limit: Int, $nextToken: String, $filter: ModelSavedSearchFilterInput) {
    savedSearchByUser(byUserID: $byUserID, limit: $limit, nextToken: $nextToken, filter: $filter) {
      items { ${savedSearchFields} }
      nextToken
    }
  }
`

export const getSavedSearchQuery = /* GraphQL */ `
  query GetSavedSearch($id: ID!) {
    getSavedSearch(id: $id) {
      id
      byUserID
      projectID
      slug
      organizationID
      organizationMasterID
      location {
        lat
        lon
      }
      name
      source
      status
      description
      address
      conditions
      provenances
      categories
      dimensionRange {
        key
        min
        max
      }
      quantity {
        number
        unit
      }
      brands
      models
      materials
      startDate
      endDate
      createdAt
      updatedAt
    }
  }
`

export const searchSavedSearchQuery = /* GraphQL */ `
  query SearchSavedSearch(
    $location: LocationInput
    $distance: Int
    $filter: SearchSavedSearchFilterInput
    $sort: SearchProductSortInput
    $nextToken: Int
    $limit: Int
  ) {
    searchSavedSearch(
      location: $location
      distance: $distance
      filter: $filter
      sort: $sort
      nextToken: $nextToken
      limit: $limit
    ) {
      items {
        ${savedSearchFields}
      }
      total
      nextToken
    }
  }
`
